import { useLocation, useNavigate, useParams } from "react-router-dom"
import { NavigatioStateType } from "../../../../../../../utils/enums/navigatetionState"
import { useMemo } from "react"
import { formatPaths } from "../formaters"

export const useBreadcrumb = () => {
    const navigate = useNavigate()
    const { id } = useParams()
    const location = useLocation()
    const listBreadCrumb = useMemo(() => {
        const state = location?.state
        if (state?.type == NavigatioStateType.SCHEDULE) {
            return formatPaths({ id, navigate, path: 'calendar', state, })
        }
        if (state?.type == NavigatioStateType.USER_SCHEDULE) {
            return formatPaths({ id, navigate, path: 'schedule-user', state, })
        }
        return undefined
    }, [])

    return { listBreadCrumb }
}